import React from 'react'
import { SingleProductpage } from '../Components/SingleProductPage/SingleProductpage'

const Singleproductpage = () => {
  return (
    <div>
      <SingleProductpage></SingleProductpage>
    </div>
  )
}

export default Singleproductpage